"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useSubscriptionBase_1 = __importDefault(require("./useSubscriptionBase"));
// the useSubscription with the API I like
function useSubscription(query, variables, passedOptions = {}) {
    const options = {
        query,
        variables,
        ...passedOptions,
    };
    return useSubscriptionBase_1.default(options);
}
exports.default = useSubscription;
